import axios from 'modules/api-client/request';

import type { IRate, IRateOption } from './types';

export const getCourseRates = (courseId: string) => {
  return axios.get<void, IRate[]>(`/courses/${courseId}/pricing/rates`);
};

export const getRateOptionsRequest = (): Promise<IRateOption[]> => {
  return axios.get<undefined, IRateOption[]>('/admin/rate-option');
};
